import React, { useState } from "react";
import {
  Grid,
  TextField,
  Typography,
  Button,
  Box,
  InputAdornment,
  Snackbar,
  Alert,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { Link as RouterLink } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { baseapi, frontbaseapi } from "../Environmentalurl";
import {
  entity_id,
  fetchLocation,
  getGeolocation,
  Platform,
} from "../Utils/Const";
import useIPAddress from "../Utils/useIPAddress";
import { setLoginMeta } from "../Slice/authSlice";
import { useMediaQuery, useTheme } from "@mui/system";

const Passwordpage = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  // Validation rules
  const hasUpper = /[A-Z]/.test(password);
  const hasLower = /[a-z]/.test(password);
  const hasNumber = /[0-9]/.test(password);
  const hasSpecial = /[!@#$%^&*]/.test(password);
  const hasLength = password.length >= 8;

  const isPasswordValid =
    hasUpper && hasLower && hasNumber && hasSpecial && hasLength;

  const isMatch = password === confirmPassword && confirmPassword !== "";
  return (
    <>
      <Grid
        container
        sx={{
          minHeight: "100vh",
          backgroundColor: "#fff",
        }}
      >
        <Grid
          size={{ xs: 12, md: 6 }}
          item
          xs={12}
          md={6}
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{
            background: "linear-gradient(to bottom, #d7ebd9, #ffffff)",
            p: { xs: 4, sm: 6, md: 0 },
          }}
        >
          <img
            src="/Assets/loginimg.png"
            alt="Login Illustration"
            style={{
              width: "100%",
              maxWidth: "500px",
              height: "auto",
              objectFit: "contain",
            }}
          />
        </Grid>

        <Grid
          size={{ xs: 12, md: 6 }}
          item
          xs={12}
          md={6}
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{
            px: { xs: 2, sm: 4, md: 8 },
            py: { xs: 4, sm: 6, md: 0 },
          }}
        >
          <Box
            component="form"
            sx={{
              width: { xs: "100%", sm: "400px" },
              textAlign: "left",
              fontFamily: "Mulish, sans-serif",
            }}
          >
            {/* Logo */}

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: { xs: "center", md: "flex-start" }, // 🔥 main fix
                textAlign: { xs: "center", md: "left" },
              }}
            >
              <img
                src="/Assets/logota.jpg"
                alt="TA Logo"
                style={{
                  width: "150px",
                  height: "80px",
                  objectFit: "contain",
                }}
              />
            </Box>

            {/* Title */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: { xs: "center", md: "flex-start" }, // 🔥 main fix
                textAlign: { xs: "center", md: "left" },
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  fontFamily: "'Poppins', sans-serif",
                  fontWeight: 600,
                  color: "#000",
                  fontSize: { xs: "20px", sm: "24px", md: "28px" },
                }}
              >
                Set password
              </Typography>
            </Box>

            {/* Phone Number Input */}

            <Box sx={{ mt: 2 }}>
              {/* PASSWORD */}
              <TextField
                fullWidth
                type="password"
                label="Enter Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                sx={{ mb: 2 }}
              />

              {/* CONFIRM PASSWORD */}
              <TextField
                fullWidth
                type="password"
                label="Confirm Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                sx={{ mb: 1 }}
              />

              {/* MATCH ERROR */}
              {!isMatch && confirmPassword && (
                <Typography color="red" fontSize={13}>
                  Passwords do not match
                </Typography>
              )}

              {/* RULES */}
              <Box mt={1}>
                <Typography fontSize={13} color={hasUpper ? "green" : "gray"}>
                  ✔ At least 1 Capital Letter
                </Typography>
                <Typography fontSize={13} color={hasLower ? "green" : "gray"}>
                  ✔ At least 1 Small Letter
                </Typography>
                <Typography fontSize={13} color={hasNumber ? "green" : "gray"}>
                  ✔ At least 1 Number
                </Typography>
                <Typography fontSize={13} color={hasSpecial ? "green" : "gray"}>
                  ✔ At least 1 Special Character
                </Typography>
                <Typography fontSize={13} color={hasLength ? "green" : "gray"}>
                  ✔ Minimum 8 Characters
                </Typography>
              </Box>

              {/* BUTTON */}
              <Button
                fullWidth
                variant="contained"
                disabled={!isPasswordValid || !isMatch}
                sx={{
                  mt: 3,
                  backgroundColor: "green",
                  "&:hover": { backgroundColor: "darkgreen" },
                }}
              >
                Set Password
              </Button>
            </Box>

            <Typography
              variant="body2"
              sx={{
                fontSize: { xs: "13px", sm: "14px", md: "16px" },
                color: "black",
                textAlign: "center",
              }}
            >
              {/* Can’t login?{" "} */}
              <Box
                display={"flex"}
                justifyContent={"space-between"}
                px={2}
                mt={1}
              >
                <span
                  style={{
                    color: "#1976d2",
                    cursor: "pointer",
                    fontWeight: 500,
                    display: "inline-block",
                    marginTop: "6px",
                  }}
                  onClick={() => {
                    window.location.href = frontbaseapi;
                  }}
                >
                  Back
                </span>

                <Typography display="flex" alignItems="center" fontSize={15}>
                  If not registered? please&nbsp;
                  <span
                    style={{
                      color: "#1976d2",
                      cursor: "pointer",
                      fontWeight: 500,
                    }}
                  >
                    Register
                  </span>
                </Typography>
              </Box>
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default Passwordpage;
